import React, { Component } from 'react';
import { Box } from '@mui/material';

class Graph extends Component {
    state = {
        options: {
            height: 0,
            width: 0,
            animate: true
        },
        chart: []
    };

    chartDiv = null;

    componentDidMount = () => {
        this.loadChart();
    }

    componentWillUnmount = () => {
        if (this.props.chart && typeof this.props.chart.destroy === 'function') {
            try {
                this.props.chart.destroy();
            } catch (error) {
                console.error('Error destroying chart:', error);
            }
        }
    }
    
    loadChart = () => {
        if (!this.props.chart || !this.chartDiv) return;
        
        try {
            this.chartDiv.appendChild(this.props.chart.canvas);
            this.props.chart.render();
        } catch (error) {
            console.error('Error loading chart:', error);
        }
    }

    render = () => { 
        return ( 
            <Box display="flex" justifyContent="center">
                <Box ref={div => (this.chartDiv = div)} sx={{ px: 3, pb: 1 }} />
            </Box>
        );
    }
}

export default Graph;